import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDPAIT9wGUFdOr0ceKTrJyLTla0TBx3TuI",
  authDomain: "portalized-dda81.firebaseapp.com",
  projectId: "portalized-dda81",
  storageBucket: "portalized-dda81.firebasestorage.app",
  messagingSenderId: "533265159513",
  appId: "1:533265159513:web:a2ddfae868436b5e382848",
  measurementId: "G-B4VHT01QFT",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
export { app, analytics, db };
